export interface ITeam {
  id: string;
  name: string;
  emoji: string;
  users: string[];
  companyId: string;
}

export enum TeamsTab {
  USERS = 'users',
  TEAMS = 'teams',
}
